import React from 'react';
import { confirmAlert } from 'react-confirm-alert';
import styled from 'styled-components';
import 'react-confirm-alert/src/react-confirm-alert.css'; // Importa o CSS padrão

import TermoUso from './TermoUso';

const AlertContainer = styled.div`
  background-color: white;
  padding: 24px;
  border-radius: 8px;
  box-shadow: 0 10px 15px rgba(0, 0, 0, 0.1);
  max-width: 500px;
  margin: auto;
`;

const Title = styled.h1`
  font-size: 1.25rem;
  font-weight: bold;
  margin-bottom: 16px;
`;

const Message = styled.p`
  margin-bottom: 8px;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const Button = styled.button`
  background-color: #000;
  color: #fff;
  padding: 8px 16px;
  border-radius: 4px;
  font-weight: bold;
  margin-left: 8px;
  cursor: pointer;

  &:hover {
    background-color: #333;
  }
`;

// exibirTermo: mostra o PDF dos Termos de Uso e exige o aceite antes de liberar o Confirmar
const CustomAlert = ({ title, message, onConfirm, onCancel, exibirTermo = false } : any) => {
  confirmAlert({
    customUI: ({ onClose }) => {
      if (exibirTermo) {
        return <TermoUso title={title} message={message} onConfirm={onConfirm} onCancel={onCancel} onClose={onClose} />;
      }

      return (
        <AlertContainer>
          <Title>{title}</Title>
          <Message>{message}</Message>
          <ButtonContainer>
            <Button
              onClick={() => {
                onCancel();
                onClose();
              }}
            >
              Cancelar
            </Button>
            <Button
              onClick={() => {
                onConfirm();
                onClose();
              }}
            >
              Confirmar
            </Button>
          </ButtonContainer>
        </AlertContainer>
      );
    }
  });
};

export default CustomAlert;
